module.exports = __webpack_public_path__ + "static/media/unknown-hero-tablet.45a3e0b9.jpg";